<template>
  <v-row>
    <template>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.inspectionCity"
          :value.sync="cityId"
          :items="citiesByCourtType[courtTypeId]"
          :disabled="!(citiesByCourtType[courtTypeId] || []).length || disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="cityChanged"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="getCourts"
          item-value="id"
          item-text="name"
          :validates="'required'"
          :disabled="disabled"
          @change="updateCourtId"
        ></naj-input>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { caseClassificationEnum } from '@/helpers/enum';
import {
  isLaborLawsuit,
  isGeneralLawsuit,
  isCriminalLawsuit,
} from '../../../helpers/utils';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapLUTActions, mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'disabled', 'handleGetCourtsInvoker'],
  data() {
    return {
      isLaborLawsuit,
      isGeneralLawsuit,
      isCriminalLawsuit,
      cityId: null,
    };
  },
  computed: {
    ...mapState({ caseData: state => state.lawsuitRequest.case }),
    ...mapLUTState(['citiesByCourtType', 'cityCourtByType', 'laborCityCourt', 'criminalCityCourtByType']),
    ...mapGetters(['selectedCaseType']),

    courtTypeId() {
      var type =
        this.isLaborLawsuit(this.caseData) ? caseClassificationEnum.family :
          this.isGeneralLawsuit(this.caseData) ? caseClassificationEnum.general :
            this.isCriminalLawsuit(this.caseData) ? caseClassificationEnum.criminal : 0;
      return type;
    },
    getCourts() {
      if (this.isLaborLawsuit(this.caseData)) {
        return this.laborCityCourt[this.cityId];
      } else if (this.isGeneralLawsuit(this.caseData)) {
        return this.cityCourtByType[this.cityId];
      } else if (this.isCriminalLawsuit(this.caseData)) {
        return this.criminalCityCourtByType[this.cityId];
      }
      return [];

    },
  },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetCourts(invoker);
    },
    'cityId': function (value) {
      this.$set(this.caseData, 'cityId', value);
    },
    'courtId': function (value) {
      if ((this.getCourts || []).some(x => x.id == value) == false) {
        this.courtId = null;
      }

    },

  },
  mounted() {
    this.cityId = this.caseData.cityId || null;
    this.handleGetCourts('mounted');
  },

  methods: {
    ...mapActions(['']),
    ...mapLUTActions(['getCitiesByCourtType', 'getGeneralCityCourtByType', 'getCourtByLaborCity', 'getCriminalCityCourtByType']),

    cityChanged(value) {
      if (value) {
        this.updateCourtId(null);
        if (this.isGeneralLawsuit(this.caseData)) {
          this.getGeneralCityCourtByType(this.cityId)
            .then((cityCourt) => {
              this.updateCourtId((cityCourt || [{ id: null }])[0].id);
            });
        } else if (this.isLaborLawsuit(this.caseData)) {
          this.getCourtByLaborCity(this.cityId)
            .then((cityCourt) => {
              this.updateCourtId((cityCourt || [{ id: null }])[0].id);
            });
        } else if (this.isCriminalLawsuit(this.caseData)) {
          this.getCriminalCityCourtByType(this.cityId)
            .then((cityCourt) => {
              this.updateCourtId((cityCourt || [{ id: null }])[0].id);
            });
        }
      }
    },
    handleGetCourts(invoker) {
      this.getCitiesByCourtType(this.courtTypeId);
      if (this.cityId) {
        if (this.isGeneralLawsuit(this.caseData)) {
          this.getGeneralCityCourtByType(this.cityId);
        } else if (this.isLaborLawsuit(this.caseData)) {
          this.getCourtByLaborCity(this.cityId);
        } else if (this.isCriminalLawsuit(this.caseData)) {
          this.getCriminalCityCourtByType(this.cityId);
        }
      }
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>
<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
